var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none",
    viewBox: "0 0 22 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    fillRule: "evenodd",
    d: "M5.862 18.739H4.177c-.465 0-.843-.345-.843-.77V17.2a1.77 1.77 0 0 1-1.191-.45 1.474 1.474 0 0 1-.494-1.088V9.507c-.465 0-.842-.345-.842-.77V6.43c0-.425.377-.77.842-.77V2.583C1.65 1.308 2.781.275 4.177.275h13.481c1.396 0 2.528 1.033 2.528 2.308V5.66c.465 0 .843.345.843.77v2.308c0 .424-.378.77-.843.77v6.154c0 .407-.178.799-.494 1.087a1.77 1.77 0 0 1-1.191.451v.77c0 .424-.378.769-.843.769h-1.685c-.465 0-.842-.345-.842-.77V17.2H6.705v.77c0 .424-.378.769-.843.769Zm-1.264-5.385c.698 0 1.264.517 1.264 1.154 0 .637-.566 1.154-1.264 1.154-.697 0-1.264-.517-1.264-1.154 0-.637.567-1.154 1.264-1.154Zm12.64 0c.697 0 1.263.517 1.263 1.154 0 .637-.566 1.154-1.264 1.154-.698 0-1.264-.517-1.264-1.154 0-.637.566-1.154 1.264-1.154Zm-4.214.769H8.811c-.232 0-.421.172-.421.385 0 .212.189.384.421.384h4.213c.233 0 .421-.172.421-.384 0-.213-.188-.385-.42-.385Zm5.477-9.616c0-.213-.189-.385-.421-.385H3.756c-.233 0-.422.172-.422.385v6.539s2.61.769 7.584.769c4.973 0 7.583-.77 7.583-.77V4.508Zm-4.213-2.693h-6.74v.77h6.74v-.77Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.e19c280b546bb51acd21f33aa09286fa.svg";
export { ForwardRef as ReactComponent };